import React from 'react';
import { Button } from '@mui/material';
import { useTranslate } from 'react-admin';
import PropTypes from 'prop-types';
import DeleteIcon from '@/assets/icons/delete-icon.svg?react';
import { usePopoverContext } from '@/components/global/buttons/CustomMorePopover';

const CustomDeleteModalButton = ({ onOpen, label, disabled = false }) => {
    const { closePopover } = usePopoverContext();
    const translate = useTranslate();
    const buttonLabel = label || translate('common.remove');

    return (
        <Button
            onClick={() => {
                onOpen?.();
                closePopover();
            }}
            disabled={disabled}
            aria-label={buttonLabel}
        >
            <DeleteIcon /> {buttonLabel}
        </Button>
    );
};

CustomDeleteModalButton.propTypes = {
    onOpen: PropTypes.func,
    label: PropTypes.string,
    disabled: PropTypes.bool,
};

export default CustomDeleteModalButton;
